import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const BestMovesModel = ({ setMoves, onClose, isLoading }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const title = formData.get("title") || "Official Classic Level";
    const difficulty = formData.get("difficulty") || "Medium";
    const bestMoves = formData.get("bestMoves") || 4;
    const rewardCoins = formData.get("rewardCoins") || 10;

    setMoves({
      title,
      difficulty,
      bestMoves: Number(bestMoves),
      rewardCoins: Number(rewardCoins),
    });
  };

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md flex justify-center items-center z-50 p-4">
      <div className="bg-[#0f172a] border border-cyan-500/50 p-6 rounded-2xl shadow-[0_0_35px_rgba(6,182,212,0.35)] text-white min-w-[340px] max-w-[500px] w-full">
        <div className="flex justify-between items-center mb-5 pb-3 border-b border-slate-800">
          <div>
            <h2 className="text-lg font-bold text-cyan-400">⚙️ Level Configuration & Rewards</h2>
            <p className="text-xs text-slate-400">Specify level title, difficulty, solution steps, and reward coins.</p>
          </div>
          <button onClick={onClose} disabled={isLoading} className="text-slate-400 hover:text-rose-500 transition-colors p-1 disabled:opacity-50">
            <CloseIcon />
          </button>
        </div>

        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <div>
            <label className="text-xs font-bold text-slate-300 block mb-1.5">
              📌 Level Title
            </label>
            <input
              type="text"
              required
              disabled={isLoading}
              className="w-full bg-[#1e293b] border border-slate-700 rounded-xl p-3 text-white text-sm font-semibold outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 transition-all placeholder:text-slate-500 disabled:opacity-60"
              placeholder="e.g. Official Classic Level #14"
              defaultValue="Official Classic Level"
              name="title"
            />
          </div>

          <div>
            <label className="text-xs font-bold text-slate-300 block mb-1.5">
              🎯 Level Difficulty
            </label>
            <select
              name="difficulty"
              defaultValue="Medium"
              disabled={isLoading}
              className="w-full bg-[#1e293b] border border-slate-700 rounded-xl p-3 text-white text-sm font-semibold outline-none focus:border-cyan-400 transition-all disabled:opacity-60"
            >
              <option value="Easy" style={{ backgroundColor: "#0f172a", color: "#34d399" }}>🟢 Easy</option>
              <option value="Medium" style={{ backgroundColor: "#0f172a", color: "#38bdf8" }}>🔵 Medium</option>
              <option value="Hard" style={{ backgroundColor: "#0f172a", color: "#fb7185" }}>🔴 Hard</option>
              <option value="Expert" style={{ backgroundColor: "#0f172a", color: "#a855f7" }}>🟣 Expert</option>
            </select>
          </div>

          <div>
            <label className="text-xs font-bold text-slate-300 block mb-1.5">
              ⚡ Target Best Moves (Solution Step Count)
            </label>
            <input
              type="number"
              required
              disabled={isLoading}
              className="w-full bg-[#1e293b] border border-slate-700 rounded-xl p-3 text-white text-sm font-semibold outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 transition-all placeholder:text-slate-500 disabled:opacity-60"
              placeholder="e.g. 4 Moves"
              min={1}
              max={50}
              defaultValue={4}
              name="bestMoves"
            />
          </div>

          <div>
            <label className="text-xs font-bold text-amber-400 block mb-1.5">
              🪙 Win Price Reward Coins (Awarded on Completion)
            </label>
            <input
              type="number"
              required
              disabled={isLoading}
              className="w-full bg-[#1e293b] border border-slate-700 rounded-xl p-3 text-amber-400 font-bold text-sm outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-400 transition-all placeholder:text-slate-500 disabled:opacity-60"
              placeholder="e.g. 10 Coins"
              min={1}
              max={500}
              defaultValue={10}
              name="rewardCoins"
            />
          </div>

          <div className="flex justify-end gap-3 mt-4 pt-3 border-t border-slate-800">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-bold rounded-xl transition-colors disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className={`px-5 py-2.5 ${
                isLoading ? "bg-cyan-700 cursor-not-allowed opacity-80" : "bg-cyan-500 hover:bg-cyan-600"
              } text-white font-bold text-xs rounded-xl shadow-[0_0_15px_rgba(6,182,212,0.4)] transition-all flex items-center justify-center gap-2`}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Publishing Level...</span>
                </>
              ) : (
                <span>Publish Level 🚀</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BestMovesModel;
